import * as React from 'react';
import { Box, NavigationLeftIcon, RawButton, Text } from '@common-fe/common-fe';

interface Props {
  onClick: () => void;
  title?: string;
  testId?: string;
}

const BackButton: React.FC<Props> = ({ onClick, title, testId }) => (
  <RawButton onClick={onClick} data-testId={`${testId}_back-button`}>
    <Box direction="row" height="40px" align="center">
      <NavigationLeftIcon color="navigationAccent" size="18px" />
      <Text weight={700} size="medium" color="textAccent" margin={{ left: 's' }}>
        {title}
      </Text>
    </Box>
  </RawButton>
);

export default BackButton;
